import { render, staticRenderFns } from "./ModalProductPrices.vue?vue&type=template&id=44a97c70&"
import script from "./ModalProductPrices.vue?vue&type=script&lang=js&"
export * from "./ModalProductPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports